import { useState } from "react";
import PropTypes from "prop-types";

const Image = ({
  src,
  alt = "No Image",
  className = "",
  style = {},
  onClick,
}) => {
  const [error, setError] = useState(false);

  return error ? (
    <span className={className} style={style}>
      {alt}
    </span>
  ) : (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      loading="lazy"
      onError={() => setError(true)}
      onClick={onClick || null}
    />
  );
};

Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default Image;
